import React from "react";
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ExpandMoreIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";

const CustomExpansionPanel = withStyles({
    root: {
        backgroundColor: "var(--secondaryBackgroundColor)",
        margin: 0,
        width: "100%",
    },
})(ExpansionPanel);

const CustomExpansionPanelDetails = withStyles({
    root: {
        paddingTop: 0,
        width: "100%",
    },
})(ExpansionPanelDetails);

const promptListStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
    maxHeight: 240,
    overflowY: "auto",
    overflowX: "hidden",
};

const promptItemStyle = {
    backgroundColor: "rgba(128, 128, 128, 0.08)",
    border: "1px solid rgba(128, 128, 128, 0.35)",
    borderRadius: 4,
    padding: "8px 10px",
    color: "var(--mainText)",
    fontFamily: "inherit",
    fontSize: "0.875rem",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
};

// Historial de indicaciones enviadas al endpoint de generate. Se muestra
// colapsado sobre la caja de prompt para no perder el contexto de la iteración.
const PromptHistoryPanel = ({ promptHistory, prompts }) => {
    const content = typeof promptHistory === "string" ? promptHistory : typeof prompts === "string" ? prompts : "";

    if (!content || content.trim().length === 0) return null;

    return (
        <CustomExpansionPanel defaultExpanded={false}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" className="whiteText">
                    {getLocalizedString("promptHistory")}
                </Typography>
            </ExpansionPanelSummary>
            <CustomExpansionPanelDetails>
                <div style={promptListStyle}>
                    <div data-testid={"prompt-history-item"} style={promptItemStyle}>
                        {content}
                    </div>
                </div>
            </CustomExpansionPanelDetails>
        </CustomExpansionPanel>
    );
};

export default PromptHistoryPanel;
